















































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import ListUtils from '@/lib/listUtils';
import UpdateJobWorkerOfferWorkerAcceptanceRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferWorkerAcceptanceRequest';

@Component({
    name: 'JobWorkerOfferStatusSetWorkerDeclined'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorkerOffer: JobWorkerOfferDto;

  request: UpdateJobWorkerOfferWorkerAcceptanceRequest = new UpdateJobWorkerOfferWorkerAcceptanceRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateJobWorkerOfferWorkerAcceptanceRequest();
    } 
    this.$emit("closeMenu");
  }

  get declinedReasons() {
    return ListUtils.jobWorkerOfferWorkerDeclinedReasons();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
    this.request.updatedAt = this.jobWorkerOffer.updatedAt;
    await JobDetailsModule.updateJobWorkerOfferWorkerAcceptance(this.request);
    this.dialog = false;
  }
}
